import script from "./AttributedRevenue.vue?vue&type=script&setup=true&lang=ts"
export * from "./AttributedRevenue.vue?vue&type=script&setup=true&lang=ts"

import "./AttributedRevenue.vue?vue&type=style&index=0&id=1a959735&scoped=true&lang=scss"
import "./AttributedRevenue.vue?vue&type=style&index=1&id=1a959735&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a959735"]])

export default __exports__